<template>
  <div class="drag-handle">
    <div class="pa-2 text-xs-center">
      <label class="image-upload-label d-block">
        <input
          ref="fileInput"
          type="file"
          accept="image/jpeg,image/png,image/gif,image/webp"
          class="d-none"
          :disabled="isUploading"
          @change="onFileSelected"
        />
        <span v-if="isUploading" class="upload-status">Uploading...</span>
        <span v-else class="upload-status">Click to upload image</span>
      </label>
      <BaseButtonOutline small outline-color="blue" class="mt-2" @click="showGallery = true">
        Choose from Gallery
      </BaseButtonOutline>
      <div v-if="uploadError" class="upload-error red--text text--darken-2 mt-2">{{ uploadError }}</div>
    </div>
    <MediaGalleryModal
      :show="showGallery"
      :site-id="siteId"
      @close="showGallery = false"
      @select="onGallerySelect"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@services/api'
import MediaGalleryModal from '@modals/MediaGalleryModal'

const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5MB

export default {
  name: 'LayoutImageUploadArea',
  components: { MediaGalleryModal },
  data() {
    return {
      isUploading: false,
      uploadError: null,
      showGallery: false,
    }
  },
  computed: {
    ...mapState({ siteId: (state) => state.site.id }),
  },
  methods: {
    async onFileSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      this.uploadError = null

      if (file.size > MAX_FILE_SIZE) {
        this.uploadError = 'File size must be under 5MB'
        this.$refs.fileInput.value = ''
        return
      }

      this.isUploading = true

      try {
        const formData = new FormData()
        formData.append('asset', file)
        formData.append('title', file.name)
        formData.append('site_id', this.siteId)

        const response = await api.post('assets', formData, { timeout: 30000 })
        this.$emit('uploaded', response.data.url)
      } catch (err) {
        this.uploadError = 'Upload failed. Please try again.'
      } finally {
        this.isUploading = false
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      }
    },
    onGallerySelect(asset) {
      this.$emit('uploaded', asset.secure_url)
      this.showGallery = false
    },
  },
}
</script>

<style lang="scss" scoped>
.image-upload-label {
  padding: 24px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: #1976d2;
  }
}
.upload-status {
  color: #666;
  font-size: 14px;
}
.upload-error {
  font-size: 13px;
}
</style>
